import {BehaviorSubject} from "rxjs";
import {Injectable} from "@angular/core";
import {AssigmentModel, GenericAssigmentModel} from "../schemas/assigment.model";

@Injectable({
    providedIn: 'root',
})
export class SharedAssigmentService {
    private assignmentsSource = new BehaviorSubject<GenericAssigmentModel>({
        result: 0,
        success: false,
        message: '',
        totalRecords: 0,
        data: []
    });
    currentAssignments = this.assignmentsSource.asObservable();

    updateAssignments(assignments: GenericAssigmentModel) {
        this.assignmentsSource.next(assignments);
    }

}